import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudType, LoggedInUserModel, ModulesBasedApiSuffix, NO_DATA_FOUND_MESSAGE, columnFilterRequestUtil, debounceTimeForSearchkeyword, loadPaginationLazy } from '@app/shared';
import { RxjsService } from '@app/shared/services';
import { TableFilterFormService } from '@app/shared/services/create-form.services';
import { MomentService } from '@app/shared/services/moment.service';
import { loggedInUserData } from '@modules/others';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { Store, select } from '@ngrx/store';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'request-search-list',
  templateUrl: './request-search-list.component.html'
})
export class RequestSearchListComponent extends PrimeNgTableVariablesModel implements OnInit {
  @Input() response;
  @Input() type = 'others';
  @Output() emittedEvent = new EventEmitter();
  searchForm: FormGroup;
  columnFilterForm: FormGroup;
  searchColumns: any;
  NO_DATA_FOUND_MESSAGE = NO_DATA_FOUND_MESSAGE;

  constructor(
    private _fb: FormBuilder, private tableFilterFormService: TableFilterFormService,
    private router: Router, private store: Store<AppState>, private momentService: MomentService,
    private rxjsService: RxjsService) {
    super();
    this.store.pipe(select(loggedInUserData)).subscribe((userData: LoggedInUserModel) => {
      if (!userData) return;
      this.loggedInUserData = userData;
      this.searchForm = this._fb.group({ searchKeyword: "" });
      this.columnFilterForm = this._fb.group({});
    });
    this.primengTableConfigProperties = {
      tableCaption: "Search Results",
      tableComponentConfigs: {
        tabsList: [
          {
            caption: "Search Results",
            dataKey: 'id',
            columns: [],
            apiSuffixModel: SalesModuleApiSuffixModels.TICKETS,
            moduleName: ModulesBasedApiSuffix.SALES,
          }]
      }
    }
  }

  ngOnInit(): void {
    this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].columns = this.type == 'gis dashboard' ?
      [{ field: 'boundaryRequestRefNo', header: 'Request ID' },
      { field: 'boundaryName', header: 'Boundary Name' },
      { field: 'boundaryTypeName', header: 'Boundary Type' },
      { field: 'boundaryLayerName', header: 'Layer' },
      { field: 'divisionName', header: 'Division' },
      { field: 'districtName', header: 'District' },
      { field: 'initiator', header: 'Initiator' },
      { field: 'goLiveDate', header: 'Go Live Date' },
      { field: 'filename', header: 'File Name' },
      { field: 'description', header: 'Description' },
      { field: 'boundaryStatusName', header: 'Status' },
      { field: 'gisUser', header: 'GIS User' },
      { field: 'modifiedDate', header: 'Action Date' }] :
      [{ field: 'boundaryRequestRefNo', header: 'Request ID' },
      { field: 'boundaryName', header: 'Boundary Name' },
      { field: 'boundaryTypeName', header: 'Boundary Type' },
      { field: 'boundaryLayerName', header: 'Layer' },
      { field: 'divisionName', header: 'Division' },
      { field: 'districtName', header: 'District' },
      { field: 'boundaryStatusName', header: 'Status' }],
      this.columnFilterForm = this.tableFilterFormService.createFormGroup(this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns);
    this.rxjsService.setGlobalLoaderProperty(true);
    this.columnFilterForm.valueChanges.pipe(debounceTime(debounceTimeForSearchkeyword),
      distinctUntilChanged()).subscribe((formObject) =>
        // utitlize the common column filter util method
        columnFilterRequestUtil(this.row, this.onCRUDRequested.bind(this),
          [{ actualNameKey: 'status', alternateNameKey: 'rawLeadStatusId', alternateValueKey: 'id' },
          { actualNameKey: 'siteType', alternateNameKey: 'siteTypeId', alternateValueKey: 'id' }], formObject, this.momentService));

  }

  ngOnChanges() {
    if (this.response) {
      this.dataList = this.response.resources.boundaryRequests ? this.response.resources.boundaryRequests :
        this.response.resources;
      this.totalRecords = this.response.totalCount;
    }
  }

  loadPaginationLazy(event) {
    this.row = loadPaginationLazy(event);
    columnFilterRequestUtil(this.row, this.onCRUDRequested.bind(this), this.requestParams);
  }

  onCRUDRequested(type: CrudType | string, row?: object, requestParams?): void {
    this.requestParams = requestParams;
    switch (type) {
      case CrudType.EDIT:
        this.openAddEditPage(CrudType.EDIT, row);
        break;
      case CrudType.GET:
        this.openAddEditPage(CrudType.GET, requestParams);
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?): void {
    let urlSegments = this.type == 'gis dashboard' ? 'gis-dashboard/add-edit' : 'view-request/add-edit';
    switch (type) {
      case CrudType.EDIT:
        this.router.navigate([`/my-tasks/boundary-management/${urlSegments}`], {
          queryParams: {
            boundaryRequestId: editableObject['boundaryRequestId'],
            boundaryRequestRefNo: editableObject['boundaryRequestRefNo'],
            fromUrl: this.type == 'gis dashboard' ? 'GISDashboard' : 'MyRequestDashboard',
            regionId: editableObject['regionId'],
            layerId: editableObject['boundaryLayerId']
          }
        });
        break;
      case CrudType.GET:
        editableObject.type = this.response.resources.boundaryRequests ? 'my request' : 'all request';
        this.emittedEvent.emit(editableObject);
        break;
    }
  }
}